import {
  CPSConfig,
  CPSConfigFunctionnality,
  IProduct,
  IProductFunctionnality,
  OTAUpdateProperty,
  ProductTuto,
} from '../IProduct';
import { P00039DataRxTxIndex } from './P00039Sync';
import { P00042FunctionFinish } from './P00042/Installation/P00042InstallationFinish';
import { P00042FunctionReset } from './P00042/Installation/P00042InstallationReset';
import { Pool } from '../../../../apis/pool.api';
import { EventProductFunctionnalityEnum } from '../../../../apis/poolEvent.api';
import { environment } from '../../../../../environments/environment';
import { FunctionParametersProductComponent } from '../../../../components/ecosystems/function-parameters-product/function-parameters-product.component';
import { P00042VoletMiseEnOeuvreInit } from './P00042/Volet/miseenoeuvre/P00042VoletMiseEnOeuvreInit';

export class P00042Data {
  vo230CConfirmationOTA: number = 0;

  vo230CResetUsine: number = 0;

  vo230CCommandeCloud: number = 0;

  vo230CCommandeBLE: number = 0;

  vo230CCodeSaisi: string = '0000';

  vo230IConfigurationProduit: number = 0;

  vo230IAntenneRF: number = 0;

  vo230IActivationFonctionArretFiltration: number = 0;

  vo230IConfigurationAlimentationMoteur: number = 0;

  vo230PModeOuverture: number = 0;

  vo230PCodeDeverrouillage: string = '0000';

  vo230SAlarme: number = 0;

  vo230SProtectionInversionSens: number = 0;

  vo230SOuvertureTemporiseeEnCours: number = 0;

  vo230SEtatVolet: number = 0;

  vo230SDeverrouillage: number = 0;

  vo230SSourceCommande: number = 0;

  vo230SCommandeOuverture: number = 0;

  vo230SCommandeFermeture: number = 0;

  vo230SCommandeVolet: number = 0;

  vo230SEtatMoteur: number = 0;

  vo230SCommandeBoiteACle: number = 0;

  vo230SCommandeMaitre: number = 0;

  vo230SSourceCommandeMaitre: number = 0;

  vo230SCompteurDeverrouillage: number = 0;

  vo230SDureeFonctionnementMoteur: number = 0;

  vo230SCompteAReboursOuvertureTemporisee: number = 0;

  vo230SNombreCommutationRelaisOuverture: number = 0;

  vo230SNombreCommutationRelaisFermeture: number = 0;

  vo230SCompteurBouton: number = 0;

  vo230STempsSousTension: number = 0;

  vo230SCompteurResetUsine: number = 0;

  vo230SArretFiltration: number = 0;
}

export class P00042 extends IProduct {
  override deviceTableIndex: number = 16;

  override modelIdentifier?: string = 'P00042';

  override dataIdentifier?: string = 'P00042';

  override manufacturerName?: string = 'ACWA';

  data: P00042Data = new P00042Data();

  getProductSmallIllustration(): any {
    return '/assets/ecosystem/images/products/P00042/smallProduct.png';
  }

  getProductIllustration(): any {
    return '/assets/ecosystem/images/products/P00042/product.png';
  }

  getProductImage(): any {
    return '/assets/ecosystem/images/products/P00042/product.png';
  }

  getProductKey(): string {
    return this.modelIdentifier!;
  }

  getProductDeviceTableFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.master?.deviceTable?.P00042;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductDataFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.P00042?.data;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductTuto(): ProductTuto {
    return {
      hasHelp: true,
      helpTitle: 'P00042.tuto.installation.help.title',
      helpSlides: [
        'P00043.tuto.installation.help.1',
        'P00043.tuto.installation.help.2',
        'P00043.tuto.installation.help.3',
        'P00043.tuto.installation.help.4',
      ],
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00042/installation-1.png',
            dark: '/assets/ecosystem/images/products/P00042/installation-1_dark.png',
          },
          text: 'P00042.tuto.installation.page1',
        },
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00042/installation-2.png',
            dark: '/assets/ecosystem/images/products/P00042/installation-2_dark.png',
          },
          text: 'P00042.tuto.installation.page2',
        },
      ],
    };
  }

  getUpdateTuto(): ProductTuto {
    return {
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00042/installation-1.png',
            dark: '/assets/ecosystem/images/products/P00042/installation-1_dark.png',
          },
          text: 'P00042.tuto.update.page1',
        },
        {
          image: {
            light: '/assets/ecosystem/images/products/P00042/update-2.png',
            dark: '/assets/ecosystem/images/products/P00042/update-2_dark.png',
          },
          text: 'P00042.tuto.update.page2',
        },
      ],
    };
  }

  getCPSConfig(): CPSConfig | null {
    return {
      installation: {
        pages: [
          /*{
            component: P00042InstallationVolet, condition: () => {
              return true;
            },
          },*/
        ],
        finish: P00042FunctionFinish,
        reset: P00042FunctionReset,
      },
      controlCards: [
        //{ component: P00042CardVoletControle, weight: 5 },
      ],

      statusCards: [
        //{ component: P00042CardVoletStatut, weight: 6 },
      ],

      parametrages: {
        enabledUser: false,
        enabledSupport: false,

        general: {
          enabledUser: true,
          enabledSupport: true,
          component: FunctionParametersProductComponent,
        },
      },
    };
  }

  getEventProductFunctionalities(): EventProductFunctionnalityEnum[] {
    return [EventProductFunctionnalityEnum.COVER];
  }

  getCPSConfigByFonctionnality(
    functionnality: IProductFunctionnality,
  ): CPSConfigFunctionnality | null {
    if (functionnality == IProductFunctionnality.VOLET230) {
      return {
        miseEnOeuvre: {
          pages: [
            //{ component : P00042VoletMiseEnOeuvreVoletImmerge, condition: () => { return true; } },
          ],
          init: P00042VoletMiseEnOeuvreInit,
        },

        controle: {
          enabledUser: true,
          enabledSupport: true,

          //component: P00042VoletControle,
        },
        parametrages: {
          enabledUser: true,
          enabledSupport: true,

          reglage: {
            enabledUser: true,
            enabledSupport: true,
            //component: P00042VoletParameters,
          },
        },
        status: {
          enabledUser: true,
          enabledSupport: true,
          //component: P00042VoletStatut,
        },
        historique: {
          enabledUser: true,
          enabledSupport: true,

          suivi: {
            enabledUser: true,
            enabledSupport: true,
            //component: P00042VoletHistoriqueSuivi,
          },
        },
      };
    }
    return null;
  }

  getPropertyForOTAUpdate(): OTAUpdateProperty | null {
    return {
      index: P00039DataRxTxIndex.Volet230_Controle,
      propertyName: 'vo230CConfirmationOTA',
    };
  }

  getMinimumFirmwareVersionForBleUpdate(): number | null {
    return 20;
  }

  needConfiguration(pool: Pool): boolean {
    return this.getProductDataFromPool(pool).vo230IConfigurationProduit !== 1;
  }

  getProductVideoURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_1.mp4'
    );
  }

  getProductVideoChapterURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_1.csv'
    );
  }
}
